<template>
  <v-list-group prepend-icon="tune" active-class="activeLinkGroup" no-action>
    <v-list-tile slot="activator">
      <v-list-tile-title>{{ $t("App.Manage") }}</v-list-tile-title>
    </v-list-tile>
    <v-list v-if="isAuthed && isTenantAdmin" dense dark>
      <v-subheader class="mt-3" style="height: unset;">Discrete Data:</v-subheader>
      <v-list-tile v-if="hasSampleData" ripple :to="{name: 'analytesManage', params: {name: currentUserGroup.name}}" active-class="activeLink">
        <v-list-tile-title>{{ $t("App.Analytes") }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>group_work</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-list-tile v-if="hasSampleData" ripple :to="{ name: 'depthHeightDatums', params: { name: currentUserGroup && currentUserGroup.name } }" active-class="activeLink">
        <v-list-tile-title>{{ $t("App.depthHeightDatums") }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>height</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-list-tile v-if="hasSampleData" ripple :to="{ name: 'flagsManage', params: { tenant: currentUserGroup.name } }" active-class="activeLink">
        <v-list-tile-title>{{ $t("App.DiscreteSampleFlags") }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>flag</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-list-tile v-if="hasSampleData" ripple :to="{ name: 'guidelinesCofactorEntrance', params: {name: currentUserGroup.name} }" active-class="activeLink">
        <v-list-tile-title>{{ $t("App.guidelinesCofactorEntrance") }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>rule</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <!-- <v-list-tile :to="{ name: 'importnotifications' }" ripple active-class="activeLink">
        <v-list-tile-title>{{ $t("App.DiscreteImportNotifications") }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>notification_important</v-icon>
        </v-list-tile-avatar>
      </v-list-tile> -->

      <v-subheader class="mt-3" style="height: unset;">Continuous Data:</v-subheader>
      <v-list-tile v-if="hasContinuousData" :to="{ name: 'continuousDataOutputTenantManage' }" active-class="activeLink">
        <v-list-tile-title>Continuous Data Approval, Grades & Qualifier</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>waterfall_chart</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>

      <v-subheader class="mt-3" style="height: unset;" v-if="hasSurveyData">Survey Data:</v-subheader>
      <v-list-tile v-if="hasSurveyData" :to="{ name: 'ecosurveyingestionsmanage' }" active-class="activeLink">
        <v-list-tile-title>EcoSurvey EDD File Schemas</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>mdi-application</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>

      <v-subheader class="mt-3" style="height: unset;">Other:</v-subheader>
      <v-list-tile :to="{ name: 'fileschemasmanage' }" ripple active-class="activeLink">
        <v-list-tile-title>{{ $t("App.FileSchemas") }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>integration_instructions</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-list-tile :to="{ name: 'managemonitoringfeatures' }" ripple active-class="activeLink">
        <v-list-tile-title>Monitoring Locations</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>satellite</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
    </v-list>
  </v-list-group>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const authenticate = createNamespacedHelpers('authenticate')
  const navigation = createNamespacedHelpers('navigation')
  export default {
    computed: {
      ...authenticate.mapGetters([
        'isAuthed',
        'hasContinuousData',
        'hasSampleData',
        'hasContinuousData',
        'isTenantAdmin',
        'currentUserGroup',
      ]),
      ...navigation.mapGetters([
        'sideMenuGrouping',
        'sideMenuSettings',
      ]),
      hasSurveyData() {
        return true
        // if(this.sideMenuGrouping != null) {
        //   return (this.sideMenuGrouping.SurveyGroup != null && this.sideMenuGrouping.SurveyGroup.length > 0)
        // }
        
        // return false
      },
    },
  }
</script>